import StaticProgressBar from './StaticProgressBar';

export default StaticProgressBar;
